// extracted by mini-css-extract-plugin
module.exports = {"container":"Step_container__I1YBl","anim":"Step_anim__1qgy4","buttons":"Step_buttons__h1Uzl","icon":"Step_icon__2_lru"};